export default __webpack_public_path__ + "static/imgWarrantypng-51a56c926ce81eca3ae5583fe8f46dfc.png";